
"use client"
import Link from "next/link";
import "../components/ui/style.css";
import TypeWriter from "@/components/ui/typewriter";
import { useAuth } from "@/providers/AuthProvider";
// import 'animate.css';

export default function Index() {
  const { session } = useAuth();

  return (
    // <div className="w-full flex flex-col items-center min-h-screen">
    //   <div className="flex flex-col gap-14 max-w-4xl px-3 py-16 lg:py-24 text-foreground flex-grow">
    <div className="flex flex-col items-center mb-4 lg:mb-12">
      <div className="text-3xl lg:text-4xl !leading-tight mx-auto max-w-xl text-center my-12">
        <span className="typing-effect-fast">
          <strong>TagsForText</strong>
        </span>{" "}
        <br />
        <TypeWriter />
      </div>

      {/* Keep the same logic for user check */}
      {session ? (
        <div className="flex flex-row gap-2">
          <Link
            href="/files"
            className="bg-foreground py-3 px-6 rounded-lg font-mono text-sm text-background"
          >
            Upload
          </Link>
          <Link
            href="/chat"
            className="bg-foreground py-3 px-6 rounded-lg font-mono text-sm text-background"
          >
            Chat
          </Link>
        </div>
      ) : (
        <div className="flex flex-row gap-2">
          <Link
            href="/login"
            className="bg-foreground py-3 px-6 rounded-lg font-mono text-sm text-background"
          >
            Login
          </Link>
        </div>
      )}

      {/* Add new text lines with animations */}
      <div className="flex flex-col items-center mt-12 space-y-2">
        <p className="md:text-xl text-base text-center animate__animated animate__fadeIn animate__delay-1s">
          Secure and Private Document Storage.
        </p>
        <p className="md:text-xl text-base text-center animate__animated animate__fadeIn animate__delay-2s">
          Instant Document Analysis with AI.
        </p>
        <p className="md:text-xl text-base text-center animate__animated animate__fadeIn animate__delay-3s">
          Multi-format Support.
        </p>
      </div>
    </div>
    //   </div>
    // </div>
  );
}
